const MXNbpayOptions = [
    {
        value: "MXNSTP",
        label: "STP",
    },
    {
        value: "MXNHSBC",
        label: "HSBC",
    },
    {
        value: "MXNAZTECA",
        label: "AZTECA",
    },
    {
        value: "MXNBANAMEX",
        label: "BANAMEX",
    },
    {
        value: "MXNBANORTE",
        label: "BANORTE",
    },
    {
        value: "MXNBANREGIO",
        label: "BANREGIO",
    },
    {
        value: "MXNBANCOPPEL",
        label: "BANCOPPEL",
    },
    {
        value: "MXNSANTANDER",
        label: "SANTANDER",
    },
    {
        value: "MXNSCOTIABANK",
        label: "SCOTIABANK",
    },
    {
        value: "MXNBBVABANCOMER",
        label: "BBVABANCOMER",
    },
    {
        value: "MXNBCT",
        label: "Bancomext",
    },
    {
        value: "MXNIBA",
        label: "Inbursa",
    },
    {
        value: "MXNDSBM",
        label: "Deutsche Bank México S.A.",
    },
    {
        value: "MXNBDB",
        label: "Banco del Bajio",
    },
];

export default MXNbpayOptions;
